import React, { useState } from 'react';

import {
  Row, Col, Label,
  Input, InputGroup,
  FormFeedback, TabContent,
  TabPane, Nav, NavItem,
  NavLink, Card, Button,
  CardTitle, CardText,
} from 'reactstrap';

import api from '../../../../../api/api.js';
import apifunctions from '../../../../../api/functions.js';
import functions from '../../../../../functions';
import auth from '../../../../../auth';

import noBanner from '../../../../../../public/img/image-not-found.png';
import '../styles.css';

class TabImagenes extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { vars, getError, onChangeField, data, onDeleteImage, action } = this.props;
    const updateImage = (evt) => {
      evt.preventDefault();
      let node = document.getElementById("imageinputfile");
      if (node != undefined && node != null && node.files != null && node.files.length == 1) {
        const reject = (Image) => onChangeField('Imagen', Image);
        const resolve = (resizedImage) => onChangeField('Imagen', resizedImage);
        //functions.resizeBase64Img(1200, node.files[0]).then(resolve).catch(reject);
        functions.getB64ImageFromInputFile(node.files[0]).then(resolve).catch(reject);
      }
    };
    return (
      <TabPane tabId="2" className="">
        <Row><Col>
          <label htmlFor="imageinputfile" className="w-100 m-0 mt-2" title="Abrir Explorador de Archivos">
            <div className="">
              {
                data.Imagen == "" ?
                  <img className="rounded d-block mx-auto imagebanner" height={225} src={noBanner} alt="Imagen No Banner" />
                  :
                  <img className="rounded d-block mx-auto imagebanner" src={data.Imagen} alt="Imagen Banner" />
              }
            </div>
          </label>
          <div className="container-buttons">

            <input
              type="file" accept="image/*"
              id="imageinputfile"
              name="imageinputfile"
              style={{ color: "transparent" }}
              className={vars.disabled == true ? "d-none" : ""}
              onChange={evt => updateImage(evt)}
            />
            {
              (action == "CREATE" || action == "EDIT" || action == "BANNER") &&
              <button class="btn btn-danger" disabled={data.Imagen == ""}
                onClick={() => onChangeField('Imagen', noBanner)}
              >
                Eliminar banner
              </button>
            }

          </div>
        </Col></Row>
        <Row><Col>
          <small>Las imagenes Banner han de ocupar todo el ancho de pantalla por lo que se recomienda una altura pequeña en relación al ancho.</small>
        </Col></Row>
      </TabPane>
    );
  }
}
export default TabImagenes;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Ofertas/ModalOfertas/TabBanner.js